<script>
import api from "@services/api";
import dateRangePickerConfig from "@configs/dateRangePickerConfig";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import Combo from "./comboComp.vue";

export default {
  components: { Combo },
  data: () => ({
    selected: undefined,
    periodo: null,
    customRanges: dateRangePickerConfig.customRanges,
    maxDate: dateRangePickerConfig.maxDate(),
    localeData: dateRangePickerConfig.localeData,
    dateRange: { startDate: new Date(), endDate: new Date() },
    clienteList: {},
    consultorList: {},
    contratoId: null,
    projetoId: null
  }),
  created() {
    let today = new Date();
    today.setHours(0, 0, 0, 0);
    let endDate = new Date(today.getFullYear(), today.getMonth(), 0);
    let startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);

    this.dateRange = {
      startDate: startDate,
      endDate: endDate
    };    
  },
  methods: {    
    downloadPdf() {
      api
        .get(`api/Atendimento/Extrato`, {
          params: {
            dataInicial: this.dateRange.startDate,
            dataFinal: this.dateRange.endDate,
            consultorId: this.selected.consultorId
              ? this.selected.consultorId
              : null,
            contratoId: this.contratoId
              ? this.contratoId
              : null,
            projetoId: this.projetoId
          }
        })
        .then(response => {
          this.$helper.callDownload(response.data["data"]);
        });
    },
    downloadCsv() {
      api
        .get(`api/Atendimento/Csv`, {
          params: {
            dataInicial: this.dateRange.startDate,
            dataFinal: this.dateRange.endDate,
            contratoId: this.selected.contratoId
              ? this.selected.contratoId
              : null
          }
        })
        .then(response => {
          this.$helper.callDownload(response.data["data"]);
        });
    },
    atualizarPorCombo(msg){
      this.dateRange.startDate = msg.dataInicial;
      this.dateRange.endDate = msg.dataFinal;
      this.selected = msg.selected;

      if(msg.selected === undefined){
         this.contratoId = null;   
      }
      else{
        this.contratoId = msg.contratoId;
        this.projetoId = msg.projetoId;
      }
    }
  }
};
</script>

<template>
  <div class="mb-2">
    <b-form @submit.prevent="downloadPdf">
      <div class="row">

        <combo class="col-md-8"  @AtualizarData="atualizarPorCombo" ></combo>

      </div>
      <b-button
        class="btn"
        variant="primary"
        type="submit"
        :disabled="selected === undefined"
        >Exportar PDF
      </b-button>
      <b-button
        class="btn ml-2"
        variant="primary"
        :disabled="selected === undefined"
        v-on:click="downloadCsv()"
        >Exportar CSV
      </b-button>
    </b-form>
  </div>
  <!-- end card-box -->
</template>
